module.exports = __webpack_public_path__ + "img/full7-min.a2a299be.png";